export const loadActiveAccountId = () => {
  try {
    return localStorage.getItem('activeAccountId') || null;
  } catch {
    return null;
  }
};

export const saveActiveAccountId = (id) => {
  try {
    if (id) localStorage.setItem('activeAccountId', id);
  } catch {}
};

export const clearActiveAccountId = () => {
  try {
    localStorage.removeItem('activeAccountId');
  } catch {}
};
